import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React from "react";
import { useTheme } from "@mui/material";
import Calendar from "@icons/myicons/calendar.svg?react";

export interface Props {
  className?: string;
  date: Date;
  label: string;
  handleChange: (date: Date) => void;
  disableOpenPicker?: boolean;
  desktopVariant?: boolean;
}

export const DatePickerWithQuoteLookup = ({
  className,
  date,
  label,
  handleChange,
  disableOpenPicker = false,
  desktopVariant = false,
}: Props) => {
  const theme = useTheme();
  const handleDatePickerChange = (date?: Date | null) => {
    if (!date) return;
    handleChange(date);
  };

  return (
    <>
      {desktopVariant ? (
        <DesktopDatePicker
          className={className}
          data-testid="date-picker"
          disableFuture
          openTo="year"
          format="dd.MM.yyyy"
          label={label}
          views={["year", "month", "day"]}
          value={date}
          disableOpenPicker={disableOpenPicker}
          slots={{
            openPickerIcon: () => <Calendar width="20px" height="20px" />,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              inputProps: {
                "data-testid": "date-picker-input",
              },
            },
            // Render the calendar popper inside the surrounding modal's DOM so
            // it stays within the modal's focus trap (otherwise the modal's
            // focus enforcement closes it immediately — notably in Firefox).
            // Position it "fixed" so the modal's overflow does not clip it.
            popper: {
              disablePortal: true,
              popperOptions: { strategy: "fixed" },
            },
          }}
          onChange={handleDatePickerChange}
        />
      ) : (
        <DatePicker
          className={className}
          data-testid="date-picker"
          disableFuture
          openTo="year"
          format="dd.MM.yyyy"
          label={label}
          views={["year", "month", "day"]}
          value={date}
          disableOpenPicker={disableOpenPicker}
          slots={{
            openPickerIcon: () => <Calendar width="20px" height="20px" />,
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: {
                "& .MuiFormLabel-root": {
                  color:
                    theme.type === "finanzfluss"
                      ? theme.palette.text.secondary
                      : "unset",
                },
              },
              inputProps: {
                "data-testid": "date-picker-input",
              },
            },
            // Render the calendar popper inside the surrounding modal's DOM so
            // it stays within the modal's focus trap (otherwise the modal's
            // focus enforcement closes it immediately — notably in Firefox).
            // Position it "fixed" so the modal's overflow does not clip it.
            popper: {
              disablePortal: true,
              popperOptions: { strategy: "fixed" },
            },
          }}
          onChange={handleDatePickerChange}
        />
      )}
    </>
  );
};
